import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Alert from '@mui/material/Alert';
import { useContext, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { sendFileToCustomEndpoint, uploadFile } from '../../API/api';
import appContext from '../../appContext';
import { debounce, paramsToObject, titleFromParams } from '../../Utilities/helperFunction';
import AutoComplete from '../AutoComplete';
import Fileupload from '../Fileupload';
import Scanner from '../Scanner';
import TextareaComponent from '../TextArea/TextArea';
import TextEditor from '../TextEditor';
import './style.scss';

function Input({ setScrollDisable, setExpertText, isValidEmail, mock, index, rightIcon, setValue, initialValues, maintainValues, setMaintainValues, isValidUrl, category, fileNames, setFileNames, setIsLoading, countryArray, country }) {
  const { setCustomStyles, isCdrReport, customStyles } = useContext(appContext)
  const [triggerAlert, setTriggerAlert] = useState({
    status: false,
    msg: ""
  });
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [currentScannerName, setCurrentScannerName] = useState("");

  const resetAlert = () => {
    setTimeout(() => {
      setTriggerAlert({
        status: false,
        msg: ""
      })
    }, 3000)
  }

  const debouncedChange = debounce((isDecimal) => {
    if (isDecimal) {
      setTriggerAlert({
        status: true,
        msg: "Decimal digits more than this not allowed"
      })
    } else {
      setTriggerAlert({
        status: true,
        msg: "Number only please"
      })
    }
    resetAlert()
  }, 200);

  const handleNumber = (e, i, name, isDecimal, decimalNumber, rule) => {
    let reg = ""
    if (isDecimal) {
      reg = new RegExp(`^\\d*\\.?\\d{0,${decimalNumber || 2}}$`);
    } else {
      reg = new RegExp("^[0-9]*$");
    }
    if (reg.test(e.target.value)) {
      if (rule?.max) {
        if (e.target.value.length > rule.max) {
          return
        }
      }
      setValue(initialValues[index - 1][i], e.target.value)
      setMaintainValues({ ...maintainValues, [`${name}`]: e.target.value })
    } else {
      if (isDecimal && !isNaN(e.target.value)) {
        debouncedChange(true)
      } else {
        debouncedChange(false)
      }
      e.preventDefault()
    }
  }


  const handleFile = async (acceptedFiles, i, name, allowedFileTypes = null) => {
    if (acceptedFiles?.length) {
      // Dynamic file type validation
      if (allowedFileTypes && allowedFileTypes.length > 0) {
        const invalidFiles = acceptedFiles.filter(file => {
          const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
          const mimeType = file.type;

          // Check if file matches any of the allowed types (either by MIME type or extension)
          return !allowedFileTypes.some(allowedType => {
            if (allowedType.startsWith('.')) {
              // Extension-based check
              return fileExtension === allowedType.toLowerCase();
            } else {
              // MIME type-based check (supports wildcards like image/*, video/*)
              if (allowedType.includes('*')) {
                const typePrefix = allowedType.split('/')[0];
                return mimeType.startsWith(typePrefix + '/');
              }
              return mimeType === allowedType;
            }
          });
        });

        if (invalidFiles.length > 0) {
          const allowedTypesStr = allowedFileTypes.join(', ');
          setTriggerAlert({
            status: true,
            msg: `Please upload only files of type: ${allowedTypesStr}`
          })
          resetAlert()
          return;
        }
      }
      if (isCdrReport) {
        const csvFiles = acceptedFiles.filter(file => file.type === 'text/csv' || file.name.endsWith('.csv'));
        if (csvFiles.length < acceptedFiles?.length) {
          setTriggerAlert({
            status: true,
            msg: 'Please upload only CSV files.'
          })
          resetAlert()
          return;
        }
      }
      let formData = new FormData();
      setValue(name, undefined);
      const names = [];
      if (!Array.isArray(fileNames[index - 1])) {
        fileNames[index - 1] = []
      }
      acceptedFiles.forEach((x) => {
        names?.push(x?.name);
        formData.append('file', x);
        fileNames[index - 1][i] = [...names];
        setFileNames([...fileNames])
      })
      setIsLoading(true)
      const fileRes = await uploadFile(formData, atob(sessionStorage?.formUUID), sessionStorage?.principalId)
      if (fileRes?.url && fileRes?.url?.length) {
        setValue(name, fileRes.url);
        maintainValues[`${name}`] = fileRes.url;
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
        fileNames[index - 1][i] = [];
      }
      if (mock?.sendFileToApi && mock?.postApiDetails?.endpoint) {
        await sendFileToCustomEndpoint(mock?.postApiDetails?.endpoint, formData)
      }
    } else {
      const allowedTypesStr = allowedFileTypes.join(', ');
      setTriggerAlert({
        status: true,
        msg: `Please upload only files of type: ${allowedTypesStr}`
      })
      resetAlert()
      return;
    }
  }

  const handleInputChange = (e, name, rule) => {
    if (rule?.max) {
      if (e.target.value.length > rule.max) {
        return
      }
    }
    setValue(name, e?.target?.value);
    setMaintainValues({ ...maintainValues, [`${name}`]: e?.target?.value })
  }

  const handleScan = (data) => {
    if (currentScannerName) {
      setValue(currentScannerName, data);
      setMaintainValues({ ...maintainValues, [`${currentScannerName}`]: data });
    }
    setIsScannerOpen(false);
  };

  const openScanner = (name) => {
    setCurrentScannerName(name);
    setIsScannerOpen(true);
  };


  useEffect(() => {
    setCustomStyles(mock?.styles || {})
    const inputVal = paramsToObject()
    if (inputVal) {
      mock.options.forEach((x) => {
        if (inputVal[x?.name] && !maintainValues[x?.name]) {
          maintainValues[x?.name] = inputVal[x?.name];
        }
      })
      setMaintainValues({ ...maintainValues })
    }
    const linkedDetails = sessionStorage.getItem('linkedinDetails')
    const linkedinData = JSON.parse(linkedDetails || null);
    const maintainValuesCopy = { ...maintainValues }
    if (!maintainValues["submitter_email"] && linkedinData?.email) {
      setValue("submitter_email", linkedinData.email);
      maintainValuesCopy[`submitter_email`] = linkedinData.email
    }
    if (!maintainValues["submitter_firstName"] && linkedinData?.localizedFirstName) {
      setValue("submitter_firstName", linkedinData.localizedFirstName);
      maintainValuesCopy[`submitter_firstName`] = linkedinData.localizedFirstName
    }
    if (!maintainValues["submitter_lastName"] && linkedinData?.localizedLastName) {
      setValue("submitter_lastName", linkedinData.localizedLastName);
      maintainValuesCopy[`submitter_lastName`] = linkedinData.localizedLastName
    }
    setMaintainValues({ ...maintainValuesCopy })
  }, [])


  useEffect(() => {
    if (category) {
      let text = ""
      category?.map((cato, index) => {
        let subText = cato?.name?.trim()
        subText = subText[0] === "/" ? subText?.replace("/", "") : subText
        subText = index < category?.length - 1 ? (subText + ", ") : (subText)
        text += subText
      })
      setExpertText(text)
    }
  }, [category])

  return (
    <div onClick={() => (index)} className={(triggerAlert?.status || !isValidUrl) ? "alert-animation" : 'input-container'}>
      <div className='input-title'>
        <h1 className='title'><span>{index}
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 24 24" >
            <path
              d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
          </svg>
        </span><div dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }} /></h1>
        <div className='description-container' dangerouslySetInnerHTML={{ __html: mock?.description }} />
      </div>
      {
        mock.options.map((moc, i) => {
          let name = ''
          if (initialValues && initialValues[index - 1] && initialValues[index - 1]?.length) {
            name = initialValues[index - 1][i]
          }
          return <div key={name + i} className='input'>
            {['number', 'decimal'].includes(moc?.type) ? <TextField
              id={name}
              label={moc?.label}
              placeholder={moc?.placeholder}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
              error={triggerAlert?.status}
              value={maintainValues[name] ?? ""}
              name={name}
              onChange={(e) => handleNumber(e, i, name, moc?.type === 'decimal', moc?.max_decimal, moc.rule)}
            />

              : moc.type === 'url' ?
                <TextField
                  id="standard"
                  label={moc?.label}
                  placeholder={moc?.placeholder}
                  onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name={name}
                  onChange={(e) => { setValue(name, e.target.value); setMaintainValues({ ...maintainValues, [`${name}`]: e?.target?.value }) }}
                  value={maintainValues[name] ?? ""}
                />
                : moc.type === "file" ?
                  <Fileupload
                    fileNames={fileNames}
                    handleFile={(acceptedFiles, i, name) => handleFile(acceptedFiles, i, name, moc.allowedFileTypes)}
                    name={name}
                    i={i}
                    index={index}
                    allowedFileTypes={moc.allowedFileTypes}
                  />
                  : moc.type === 'textEditor' ?
                    <TextEditor
                      setExpertText={setExpertText}
                      isValidEmail={isValidEmail}
                      mock={mock}
                      index={index}
                      rightIcon={rightIcon}
                      setValue={setValue}
                      initialValues={initialValues}
                      maintainValues={maintainValues}
                      setMaintainValues={setMaintainValues}
                    /> :
                    moc.type === 'textArea' ?
                      <TextareaComponent
                        setScrollDisable={setScrollDisable}
                        name={name}
                        maintainValues={maintainValues}
                        setMaintainValues={setMaintainValues}
                        setValue={setValue}
                        placeholder={moc?.placeholder}
                        label={moc?.label}
                      />
                      : moc.type === 'scanner' ?
                        <div className="scanner-input-wrapper">
                          <TextField
                            id="standard"
                            label={moc?.label}
                            className='scanner-input'
                            placeholder={moc?.placeholder || "Scan QR/Barcode"}
                            onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onClick={() => openScanner(name)}
                            name={name}
                            value={maintainValues[name] ?? ""}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  {maintainValues[name] && (
                                    <div onClick={(e) => { e.stopPropagation(); setValue(name, ""); setMaintainValues({ ...maintainValues, [name]: "" }) }} style={{ cursor: 'pointer', display: 'flex', color: customStyles?.color || 'inherit' }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24" fill="currentColor">
                                        <path d="M256 760l224-224 224 224 56-56-224-224 224-224-56-56-224 224-224-224-56 56 224 224-224 224 56 56Z" />
                                      </svg>
                                    </div>
                                  )}
                                  <div onClick={() => openScanner(name)} style={{ cursor: 'pointer', display: 'flex', color: customStyles?.color || 'inherit' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24" fill="currentColor">
                                      <path d="M120 896v-180h60v120h120v60H120Zm540 0v-60h120V716h60v180H660ZM120 416V236h180v60H180v120h-60Zm660 0V296H660v-60h180v180h-60ZM260 736q-24 0-42-18t-18-42V476q0-24 18-42t42-18h440q24 0 42 18t18 42v200q0 24-18 42t-42 18H260Zm0-60h440V476H260v200Zm0 0V476v200Z" />
                                    </svg>
                                  </div>
                                </div>
                              )
                            }}
                          />
                        </div>
                        :
                        moc.type === "country" ?
                          <AutoComplete
                            setScrollDisable={setScrollDisable}
                            countryArray={countryArray}
                            country={country}
                            mock={moc}
                            index={index + 1}
                            initialValues={initialValues}
                            setValue={setValue}
                            maintainValues={maintainValues}
                            setMaintainValues={setMaintainValues}
                            isCountry={true}
                            dontShowQuestDesc={true}
                            name={name}
                          />
                          :
                          moc.type === "phoneNumber" ?
                            <div
                              style={{ marginTop: '16px' }}
                              className="phone-number-wrapper"
                              onMouseEnter={() => setScrollDisable(true)}
                              onMouseLeave={() => setScrollDisable(false)}
                            >
                              <InputLabel shrink htmlFor={name} style={{ color: 'var(--color)' }}>{moc?.label}</InputLabel>
                              <PhoneInput
                                country={country ? country.toLowerCase() : "us"}
                                placeholder={moc?.placeholder}
                                inputProps={{ name: name, required: moc?.isRequired ?? true, autoFocus: true, id: name }}
                                onChange={(e) => { setValue(name, e); setMaintainValues({ ...maintainValues, [`${name}`]: e }); }}
                                value={maintainValues[name]}
                                onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              />
                            </div>
                            :
                            <TextField
                              id="standard"
                              label={moc?.label}
                              placeholder={moc?.placeholder}
                              onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name={name}
                              onChange={(e) => handleInputChange(e, name, moc.rule)}
                              value={maintainValues[name] ?? ""}
                            />

            }
          </div>
        })
      }
      {!isValidUrl && <Alert className={isValidUrl ? 'alert' : 'alert warning'} severity="error">Looks like the URL is not valid</Alert>}
      {!isValidEmail && <Alert className={isValidEmail ? 'alert' : 'alert warning'} severity="error">Please enter valid email</Alert>}
      {triggerAlert?.status && <Alert className={!triggerAlert?.status ? 'alert' : 'alert warning'} severity="error">{triggerAlert?.msg}</Alert>}
      <Scanner
        isOpen={isScannerOpen}
        onScan={handleScan}
        onClose={() => setIsScannerOpen(false)}
      />
    </div>
  )
}

export default Input